export default __webpack_public_path__ + "static/media/Draw Ticket.93845fd2.svg";